module.exports = new __parcel__URL__("super-mario-bros.c95070a5.jpg").toString();